export default __webpack_public_path__ + "static/media/sad_face.f639c861.svg";